import { render, staticRenderFns } from "./PageMathSelectGame.vue?vue&type=template&id=0c84faea&scoped=true&"
import script from "./PageMathSelectGame.vue?vue&type=script&lang=js&"
export * from "./PageMathSelectGame.vue?vue&type=script&lang=js&"
import style0 from "./PageMathSelectGame.vue?vue&type=style&index=0&id=0c84faea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84faea",
  null
  
)

export default component.exports